// GET /cities?q=
import { z } from 'zod'
import { idSchema } from './common.js'

export const cityDtoSchema = z.object({
  id: idSchema,
  name: z.string(),
  region: z.string().nullable(),
  country: z.string(),
  lat: z.number(),
  lon: z.number(),
  tz: z.string(), // IANA timezone справочника, например 'Europe/Moscow'
})
export type CityDto = z.infer<typeof cityDtoSchema>

export const searchCitiesQuerySchema = z.object({
  // Пустая строка допустима: так шторка выбора города просит список популярных,
  // не дожидаясь ввода. Отдельной ручки под это заводить не стали.
  q: z.string().default(''),
})
export type SearchCitiesQuery = z.infer<typeof searchCitiesQuerySchema>

export const searchCitiesResponseSchema = z.object({
  items: z.array(cityDtoSchema),
})
export type SearchCitiesResponse = z.infer<typeof searchCitiesResponseSchema>
